import { MODEL__NAME__ACCOUNT } from '../../dictionaries/Models.dic';
import Core from '../../lib/Core';
import Checkbox from '../Layout/Wrappers/Checkbox';
import IconButton from '../Layout/Wrappers/IconButton';
import {
  reactTableMoreMenuOptions
} from './3DotsMenu/moreMenuOptions';
import MoreOptionsMenu from './3DotsMenu/MoreOptionsMenu';

export function FilterActionsColumn(props) {
  const {
    context: { config },
    filters = {},
    setFilters = () => { },
    setInvertExpanded = () => { },
    invertExpanded,
  } = props;
  const {
    starredAccessor = '',
    ExpandedView,
    disabledStarred,
  } = config;
  const starred = !!filters[`${starredAccessor}.starred`];
  const YES__ACCOUNT_ENTITY = (
    props?.context?.config?.Entity?.name === MODEL__NAME__ACCOUNT
  );
  return (
    <div className="d-flex flex-align-right-center">
      {ExpandedView && (
        <IconButton
          title="Click to show engagements"
          onClick={event => {
            setInvertExpanded(!invertExpanded);
          }}>
          <i className="material-icons">
            {invertExpanded ? 'expand_less' : 'expand_more'}
          </i>
        </IconButton>
      )}
      {!disabledStarred && (
        <Checkbox
          title="Click to filter by starred"
          className="star"
          checked={starred}
          onChange={event => {
            const value = event.target.checked || undefined;
            const PROP__NAME__USER = (
              YES__ACCOUNT_ENTITY
                ? 'userId'
                : 'accountId'
            );
            if (value) {
              setFilters({
                ...filters,
                [`${starredAccessor}.starred`]: true,
                [`${starredAccessor}.${PROP__NAME__USER}`]: {
                  "$id": Core.getUserId()
                },
              });
            }
            else {
              let _filters = { ...filters };
              delete _filters[`${starredAccessor}.starred`];
              delete _filters[`${starredAccessor}.${PROP__NAME__USER}`];
              setFilters(_filters);
            }
          }}
          checkedIcon={<i className="material-icons">star</i>}
          icon={<i className="material-icons">star_border</i>}
        />
      )}
      <MoreOptionsMenu {...props} overrideOptions={reactTableMoreMenuOptions} />
    </div>
  );
}
